<p-toast></p-toast>

<app-page-shell>

    <app-page-detail-hero [auditStamp]="trailerType ? { createdAt: trailerType.createdAt, updatedAt: trailerType.updatedAt } : null"
        icon="pi pi-tags"
        eyebrow="Trailer Type"
        [title]="trailerType?.name || '-'"
        [subtitle]="trailerType?.code || '-'">
        <div tags>
            <p-tag [value]="trailerType?.active === false ? 'Inactive' : 'Active'" [severity]="statusSeverity(trailerType?.active)"></p-tag>
        </div>
        <div actions>
            <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" (onClick)="back()"></p-button>
            <p-button label="Edit" icon="pi pi-pencil" (onClick)="edit()"></p-button>
        </div>
    </app-page-detail-hero>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Type Metadata" subtitle="Read-only master-data fields.">
        <div class="info-grid">
            <div>
                <span>Code</span>
                <strong>{{ trailerType?.code || '-' }}</strong>
            </div>
            <div>
                <span>Name</span>
                <strong>{{ trailerType?.name || '-' }}</strong>
            </div>
            <div>
                <span>Description</span>
                <strong>{{ trailerType?.description || '-' }}</strong>
            </div>
        </div>
    </app-page-data-panel>

    <app-page-data-panel title="Linked Trailers" subtitle="Trailer assets currently classified under this type." [resultText]="trailers.length + ' loaded'">
        <p-table [value]="trailers" [loading]="isLoading" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Asset</th>
                    <th>Plate</th>
                    <th>Registration</th>
                    <th>Status</th>
                    <th>Active</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td class="font-semibold">{{ row.assetNumber || '-' }}</td>
                    <td>{{ row.plateNumber || '-' }}</td>
                    <td>{{ row.registrationNumber || '-' }}</td>
                    <td><p-tag [value]="row.status || 'AVAILABLE'" severity="info"></p-tag></td>
                    <td><p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="statusSeverity(row.active)"></p-tag></td>
                    <td class="row-actions">
                        <p-button icon="pi pi-eye" [rounded]="true" [text]="true" (onClick)="openTrailer(row)" ariaLabel="View trailer"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="6" class="empty-cell">No trailers linked to this type.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
